import { generateId } from '@freelancer/datastore/testing/helpers';
import type { AdminThread } from './admin-threads.model';
import type { ThreadContext } from '../threads/threads.model';

export interface GenerateAdminThreadOptions {
  readonly id?: number;
  readonly owner: number;
  readonly otherMembers: readonly number[];
  readonly context: ThreadContext;
  readonly inactiveMembers?: readonly number[];
  readonly timeCreated?: number;
}

export function generateAdminThreadObject({
  id = generateId(),
  owner,
  otherMembers,
  context,
  inactiveMembers = [],
  timeCreated = Date.now(),
}: GenerateAdminThreadOptions): AdminThread {
  return {
    context,
    id,
    inactiveMembers,
    members: [...otherMembers, owner],
    owner,
    timeCreated,
  };
}
